const React = require('react');
const warning = require('warning');
const PropTypes = React.PropTypes;
const classNames = require('classnames');

/**
 * TextField
 *
 * TextField must be used in controlled mode. Otherwise,
 * filled CSS states will not be computed properly.
 *
 */
const TextField = React.createClass({

  propTypes: {
    className: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    modifiers: PropTypes.arrayOf(
      PropTypes.oneOf(['inverse', 'hidesLabel', 'error']),
    ),
    onChange: PropTypes.func,
    onEnterKeyPressed: PropTypes.func,
    value: PropTypes.string,
    valueLink: PropTypes.object,
    hideLabelOnFill: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      modifiers: [],
    };
  },

  componentWillMount() {
    const { value, valueLink, hideLabelOnFill, error } = this.props;
    const parentComponentName = this._reactInternalInstance._currentElement._owner.getName(); // TODO(react-owner)

    warning(
      value !== undefined || typeof valueLink === 'object' && valueLink.constructor.name === 'ReactLink',
      `TextField in uncontrolled component mode will not properly compute CSS states. Check the render method of \`${ parentComponentName }\`.`,
    );

    warning(
      !hideLabelOnFill,
      `The \`TextField\` prop \`hideLabelOnFill\` is deprecated. Consider using \`hidesLabel\` via the \`modifiers\` prop. Check the render method of \`${ parentComponentName }\`.`,
    );

    warning(
      !error,
      `The \`TextField\` prop \`error\` is deprecated. Consider using \`error\` via the \`modifiers\` prop. Check the render method of \`${ parentComponentName }\`.`,
    );
  },

  _keyUp(e) {
    if (this.props.onEnterKeyPressed && e.key === 'Enter') {
      this.props.onEnterKeyPressed();
    }
  },

  focus() {
    this.refs.input.focus();
  },

  blur() {
    this.refs.input.blur();
  },

  render() {
    const {
      className,
      modifiers,
      hideLabelOnFill,
      error,
      helperText,
      label,
      // specified to be excluded from passedProps:
      onEnterKeyPressed,
      ...passedProps,
    } = this.props;

    const groupClasses = classNames(className, 'TextField-group', {
      'is-error': error || modifiers.includes('error'),
    });

    // valueCheck is only used for .is-filled computation
    const {
      value: valueCheck = (this.props.valueLink ? this.props.valueLink.value : undefined),
    } = this.props;

    const inputClasses = classNames('TextField', {
      'TextField--hidesLabel': hideLabelOnFill,
      'is-filled': valueCheck,
    }, modifiers.map(m => `TextField--${ m }`));

    const helperDisplay = helperText ? (
      <aside className="TextField-helper">{ helperText }</aside>
    ) : null;

    return (
      <div className={ groupClasses }>
        <input ref="input" { ...passedProps } className={ inputClasses } onKeyUp={ this._keyUp } />
        <label className="TextField-label">{ label }</label>
        { helperDisplay }
      </div>
    );
  },

});

module.exports = TextField;
